<template>
  <div>
    <div class="scratch-card-wrapper">
      <div class="inner-card">
        <scratch-card
          :key="renderCount"
          :cardWidth="cardWidth"
          :cardHeight="cardHeight"
          :finishPercent="finishPercent"
          :imageUrl="qrUrl"
          :brushUrl="brushUrl"
          :forceReveal="forceReveal"
          @getRedeemAward="getRedeemAward"
        >
          <!-- <span class="finger-animate"><img src="../../assets/images/hand.png" alt=""></span> -->
          <div class="scratched-card" v-if="onlyShoppingScratch">
            <div class="upper_part" v-if="productName">
              <h2>{{ displayMessage }}</h2>
              <div class="img_wrapper cashIcon" v-if="cashIcon">
                <img :src="cashIcon" alt />
              </div>
              <div class="img_wrapper">
                <img class="product-img" :src="thumbnail" alt />
              </div>
              <div class="offer_endtime" v-if="displayTimeText != 'Expired'">
                <span class="text">छूट समाप्त :</span>
                <span class="time">{{ displayTimeText }}</span>
              </div>
              <p class="product-name">{{ productName }}</p>
              <div class="scrh-prdc-price-part">
                <span>&#8377; {{ finalPaidAmount }}</span>
                <strike>&#8377; {{ mrp }}</strike>
                <button
                  type="button"
                  class="btn"
                  v-if="scratchedProductId"
                  @click="buyNow(scratchedProductId)"
                >
                  अभी ख़रीदे
                </button>
                <span v-if="cashBackMessage" class="scratched-card-botm-text">{{
                  cashBackMessage
                }}</span>
                <span
                  v-if="displayTimeText != 'Expired'"
                  class="scratched-card-botm-text"
                  >यह ऑफर सिर्फ दिए हुए समय तक के लिए वैध है| जल्दी करे
                </span>
                <span class="scratched-card-botm-text" v-else
                  >इस ऑफर पर छूट समाप्त हो चुकी है</span
                >
              </div>
            </div>
          </div>

          <div class="scratched-card" v-if="shoppingScratchandMpoints">
            <div class="upper_part" v-if="productName">
              <h2>{{ displayMessage }}</h2>
              <div class="img_wrapper cashIcon" v-if="cashIcon">
                <img :src="cashIcon" alt />
              </div>
              <div class="img_wrapper">
                <img class="product-img" :src="thumbnail" alt />
              </div>
              <div class="offer_endtime" v-if="displayTimeText != 'Expired'">
                <span class="text">छूट समाप्त :</span>
                <span class="time">{{ displayTimeText }}</span>
              </div>
              <p class="product-name">{{ productName }}</p>
              <div class="scrh-prdc-price-part">
                <span>&#8377; {{ finalPaidAmount }}</span>
                <strike>&#8377; {{ mrp }}</strike>
                <button
                  type="button"
                  class="btn"
                  v-if="scratchedProductId"
                  @click="buyNow(scratchedProductId)"
                >
                  अभी ख़रीदे
                </button>
                <div style="display: inline-block; height: 43px">
                  <span
                    v-if="cashBackMessage"
                    class="scratched-card-botm-text"
                    >{{ cashBackMessage }}</span
                  >
                  <span
                    v-if="displayTimeText != 'Expired'"
                    class="scratched-card-botm-text"
                    >यह ऑफर सिर्फ दिए हुए समय तक के लिए वैध है| जल्दी करे
                  </span>
                  <span class="scratched-card-botm-text" v-else
                    >इस ऑफर पर छूट समाप्त हो चुकी है</span
                  >
                </div>
              </div>
            </div>
            <div class="lower_part">
              <h4 v-if="productName">
                <span>और साथ में</span>
              </h4>
              <div
                class="img_wrapper"
                style="margin-bottom: 8px"
                v-if="!productName"
              >
                <img
                  src="https://cdn.mall91.com/c01e0b1d-9024-4993-8bb7-2029ebec59d8.png"
                  alt
                />
              </div>
              <span
                class="mpoints-btn"
                style="
                  width: fit-content;
                  margin: 0 auto;
                  border: 1px solid #f93;
                  border-radius: 5px;
                "
                v-if="!productName"
              >
                <img :src="rewardIcon" alt />
                {{ rewardValue }}
              </span>
              <span class="mpoints-btn" v-else>
                <img :src="rewardIcon" alt />
                {{ rewardValue }}
              </span>
            </div>
          </div>

          <div class="scratched-card" v-if="onlyMpoints">
            <div class="upper_part mpointsCoin">
              <h2>{{ displayMessage }}</h2>
              <div class="img_wrapper">
                <img
                  class="product-img"
                  src="../../assets/images/congrats.png"
                  alt
                />
              </div>
              <span class="mpoints-btn onlympoints">
                <img :src="rewardIcon" alt />
                {{ rewardValue }}
              </span>
            </div>

            <div class="scratched-card-footer">
              <p>दुसरो के साथ नीचे दिए हुए कोड को शेयर करे और पैसे जीते</p>
              <div class="footer-btns">
                <p>
                  <span>कोड</span>
                  <span>{{ referralCode }}</span>
                </p>
                <span class="footer-share-btn" @click="shareFunc()"
                  >शेयर करे</span
                >
              </div>
            </div>
          </div>
        </scratch-card>
        <span @click="closeScratch()" style="z-index: 99">
          <img src="../../assets/images/icons/shape.svg" alt />
        </span>
      </div>
    </div>
    <div class="confirmation_block" v-if="confirmation">
      <div class="modal_popup">
        <div class="modal_content">
          <div class="mall91_logo">
            <img src="../../assets/images/mall91_logo.png" alt="mall91_logo" />
          </div>
          <div class="rating_content">
            <h3>{{ $t("spreadSomeLove") }}</h3>
            <p>
              <i class="material-icons">star</i>
              <i class="material-icons">star</i>
              <i class="material-icons">star</i>
              <i class="material-icons">star</i>
              <i class="material-icons">star</i>
            </p>
          </div>
        </div>
        <button type="button" class="btn-danger" @click="notNow()">
          {{ $t("later") }}
        </button>
        <button type="button" class="btn-success" @click="rating()">
          {{ $t("rateNow") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ScratchCard from "../Common/ScratchCard";
import BRUSH from "../../assets/images/scratch-brush.png";
import QR from "../../assets/images/green-scratch.png";
import ApiCaller from "../../utils/apicaller";
import constant from "../../utils/constant";

export default {
  name: "ShowScratchCard",
  components: {
    ScratchCard,
  },
  props: {
    scratchArrayValue: {
      type: Object,
    },
    scratchSaleId: {
      type: String,
    },
    redeemId: {
      type: Number,
    },
    appId: {
      type: Number,
    },
  },
  data() {
    return {
      renderCount: 0,
      cardWidth: 295,
      cardHeight: 379,
      finishPercent: 70,
      brushUrl: BRUSH,
      qrUrl: QR,
      forceReveal: false,
      scratchArray: [],
      confirmation: false,
      displayMessage: "",
      rewardValue: "",
      congrats: "",
      offerDescription: "",
      rewardIcon: "",
      itemId: "",
      offerEndTimeMillis: "",
      onlyShoppingScratch: false,
      shoppingScratchandMpoints: false,
      onlyMpoints: false,
      productName: "",
      thumbnail: "",
      finalPaidAmount: "",
      mrp: "",
      displayTimeText: "",
      shareMessage: "",
      referralCode: "",
      cashBackMessage: "",
      cashIcon: "",
      scratchedProductId: "",
    };
  },
  methods: {
    closeScratch() {
      if (
        this.$route.name !== "detail" &&
        ((this.$route.name !== "home" &&
          this.$route.name !== "RetailShopItemList") ||
          this.$route.name !== "OneDayDelivery")
      ) {
        if (localStorage.getItem("isRating")) {
          this.confirmation = false;
          this.$emit("closeScratch");
        } else {
          this.confirmation = true;
        }
      } else {
        this.$emit("closeScratch");
      }
    },
    buyNow(id) {
      if (
        this.$route.name === "home" ||
        this.$route.name !== "RetailShopItemList" ||
        this.$route.name !== "OneDayDelivery"
      ) {
        this.$router.push("/detail/" + id + "?source=DAILY_LUCKY_SCRATCH");
        try {
          JSBridgePlugin.fireEvents("BUY_NOW_CLICK_FROM_LMALL_SCRATCH");
        } catch (err) {
          console.log(err);
        }
      } else {
        this.$router.push("/detail/" + id + "?source=PRODUCT_RATING");
      }
    },
    rating() {
      localStorage.setItem("isRating", "appRated");
      this.confirmation = false;
      this.$emit("closeScratch");
      try {
        JSBridgePlugin.openInBrowser(
          "https://play.google.com/store/apps/details?id=com.money91&hl=en_IN"
        );
      } catch (err) {
        console.log(err);
      }
    },
    notNow() {
      this.confirmation = false;
      this.$emit("closeScratch");
    },
    getRedeemAward() {
      const obj = {
        identifierId: this.scratchSaleId,
        applicationId: this.appId,
        id: this.redeemId,
      };
      this.$store
        .dispatch({
          type: "getRedeemAward",
          payload: obj,
        })
        .then((data) => {
          this.offerEndTimeMillis = data.data.offerEndTimeMillis;
          if (
            this.$route.name === "home" ||
            this.$route.name === "RetailShopItemList" ||
            this.$route.name === "OneDayDelivery"
          ) {
            this.$store.commit("isGlobalScratchScratched", true);
            try {
              JSBridgePlugin.fireEvents("SCRATCH_ON_LMALL_HOME");
            } catch (err) {
              console.log(err);
            }
          }
          if (
            data.data.offerEndTimeMillis != null &&
            data.data.offerEndTimeMillis > 0
          ) {
            const _this = this;
            _this.interval = setInterval(
              function (_this) {
                _this.displayTimeText = _this.setTimeText(
                  _this.offerEndTimeMillis
                );
              },
              1000,
              _this
            );
          }
        })
        .catch((err) => {
          if (
            err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
            err.response.data.message ==
              "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
          ) {
            try {
              _JWT.refereshToken = (res) => {
                if (res != "fail") {
                  this.$cookie.set("JWT-TOKEN", res);
                  this.getRedeemAward();
                } else {
                  this.loading = false;
                }
              };
              JSBridgePlugin.refreshTokens("_JWT.refereshToken");
            } catch (err) {
              this.loading = false;
              console.log(err);
            }
          }
        });
    },
    setTimeText(liveStartTimeMilis) {
      var text = "";
      var startDate = new Date(Number(liveStartTimeMilis));

      var now = new Date().getTime();
      var distance = startDate - now;
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      if (hours < 10) {
        hours = "0" + hours;
      }

      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      if (days > 0) {
        text = days + " : " + hours + " : " + minutes + " : " + seconds;
      } else if (hours > 0) {
        text = hours + " : " + minutes + " : " + seconds;
      } else if (minutes > 0) {
        text = "00 : " + minutes + " : " + seconds;
      } else if (seconds > 0) {
        text = "00 : " + minutes + " : " + seconds;
      } else {
        text = "Expired";
      }
      return text;
    },
    getProductDetail() {
      // const obj = {
      //   orderSourceType: "SCRATCH_VIEW",
      //   saleReferenceID: this.scratchArrayValue.scratchcardDTO.itemId
      // };
      // this.$store
      //   .dispatch({
      //     type: "getProductDetail",
      //     payload: obj
      //   })
      ApiCaller(
        constant.LOCAL_SHOP_URL,
        "get-product-detail-by-product-id/" + "772553",
        "get"
      ).then((data) => {
        this.productName = data.data.productListingDTO.productName;
        this.thumbnail =
          data.data.productListingDTO.itemMediaDTOList[0].thumbnail;
        this.finalPaidAmount = data.data.productListingDTO.sellingPrice;
        this.mrp = data.data.productListingDTO.mrp;
        this.scratchedProductId =
          data.data.productListingDTO.sellerItemRelationshipId;
      });
    },
    shareFunc() {
      const obj = {
        message: this.shareMessage,
      };
      try {
        JSBridgePlugin.share(JSON.stringify(obj));
      } catch (err) {
        console.log(err);
        window.open("whatsapp://send?text=" + this.shareMessage);
      }
    },
  },
  mounted() {
    if (this.scratchArrayValue.scratchcardDTO) {
      this.displayMessage =
        this.scratchArrayValue.scratchcardDTO.displayMessage;
      this.rewardValue = this.scratchArrayValue.scratchcardDTO.rewardValue;
      this.offerDescription =
        this.scratchArrayValue.scratchcardDTO.offerDescriptionString;
      this.rewardIcon = this.scratchArrayValue.scratchcardDTO.rewardIcon;
      this.clickUrl = this.scratchArrayValue.scratchcardDTO.clickUrl;
      this.itemId = this.scratchArrayValue.scratchcardDTO.itemId;
      this.shareMessage = this.scratchArrayValue.scratchcardDTO.shareMessage;
      this.referralCode = this.scratchArrayValue.referralCode;
      this.cashBackMessage = this.scratchArrayValue.cashBackMessage;
      this.cashIcon = this.scratchArrayValue.cashIcon;
    }
    if (
      this.scratchArrayValue.scratchcardDTO.itemId &&
      this.scratchArrayValue.scratchcardDTO.rewardValue
    ) {
      this.getProductDetail();
      this.shoppingScratchandMpoints = true;
    }
    if (
      this.scratchArrayValue.scratchcardDTO.itemId &&
      this.scratchArrayValue.scratchcardDTO.rewardValue == null
    ) {
      this.getProductDetail();
      this.onlyShoppingScratch = true;
    }

    if (
      this.scratchArrayValue.scratchcardDTO.itemId == null &&
      this.scratchArrayValue.scratchcardDTO.rewardValue
    ) {
      this.onlyMpoints = true;
    }
  },
};
</script>
